import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addBranchHr = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Branch',
    body
  );
  return data;
});
export const updateBranchHr = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Branch/${id}`,
    body
  );
  return data;
});

export const getBranchHr = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Branch'
  );
  return data;
});
export const deleteBranchHr = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Branch/${record}`
  );
  return data;
});
export const getBranchHrDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Branch/${id}`
  );
  return data;
});
